import "@fontsource/inter";
import { BrowserRouter } from "react-router-dom";
import { RouteDefinitions } from "./scaffold/ui/Routing";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { RequestNotifier } from "./store/utils/requestNotifier";
import { useTranslation } from "react-i18next";
import "dayjs/locale/de";

declare module "@mui/material/styles" {
  interface Palette {
    border: {
      main: string;
      secondary: string;
      subform: string;
    };
    backgroundColor: {
      main: string;
      secondary: string;
    };
    companyMain: {
      main: string;
      hover: string;
    };
    textMain: {
      main: string;
      secondary: string;
      black: string;
    };
    warningColor: {
      main: string;
    };
  }
  interface PaletteOptions {
    border: {
      main: string;
      secondary: string;
      subform: string;
    };
    backgroundColor: {
      main: string;
      secondary: string;
    };
    companyMain: {
      main: string;
      hover: string;
    };
    textMain: {
      main: string;
      secondary: string;
      black: string;
    };
    warningColor: {
      main: string;
    };
  }
}

export const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: "#43B8BB",
      },
      secondary: {
        main: "#C5BEA2",
      },
      border: {
        main: "#e7e7e7",
        secondary: "#333333",
        subform: "#707070",
      },
      backgroundColor: {
        main: "#fff",
        secondary: "#f1f5f9",
      },
      companyMain: {
        main: "#43B8BB",
        hover: "#3da5a9",
      },
      textMain: {
        main: "#404040",
        secondary: "#b7b5b5",
        black: "#000",
      },
      warningColor: {
        main: "#be2621",
      },
      action: {
        hover: "#f5f5f5",
      }
    },
    typography: {
      h1: { fontSize: "3rem", fontWeight: "700" },
      h2: { fontSize: "2.5rem", fontWeight: "700" },
      h3: { fontSize: "2.2rem", fontWeight: "700" },
      h4: { fontSize: "1.75rem", fontWeight: "700" },
      h5: { fontSize: "1.5rem", fontWeight: "700" },
      h6: { fontSize: "1.25rem", fontWeight: "700" },
      subtitle1: {
        fontSize: "1.25rem",
      },
    },
  })
);

function App() {
  const { i18n } = useTranslation();
  const adapterLocale = i18n.language?.startsWith("de") ? "de" : "en";
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
        <Provider store={store}>
          <BrowserRouter>
            <>
              <RouteDefinitions />
              <RequestNotifier />
            </>
          </BrowserRouter>
        </Provider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
